/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useRef } from "react";

import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import print from "../../../../icons/print.png";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";

function Oylik({
  setLocations,
  setLabels,
  region,
  district,
  setData,
  data,
  selectedRowKeys,
  setSelectedRowKeys,
  setLoading,
  loading,
}) {
  const conponentPDF = useRef();
  const [date, setDate] = useState(new Date().toISOString().slice(0, 4));
  const [ldate, setLdate] = useState(date);

  const memo = {};

  const filteredValue = (v) => {
    if (memo[v] !== undefined) return memo[v];
    const num = parseFloat(v);
    if (isNaN(num)) return (memo[v] = null);
    const floored = Math.floor(num * 100) / 100;
    return (memo[v] = floored % 1 === 0 ? floored : floored.toFixed(2));
  };

  const sortByVolume = (arr) => {
    if (!Array.isArray(arr)) return [];

    return arr
      .map((item) => {
        const updatedData = item.data.map((point) => {
          const vol = filteredValue(point?.volume);
          return { ...point, volume: vol };
        });

        const volumeCount = updatedData.filter((point) => {
          return point.volume != null;
        }).length;

        return { ...item, data: updatedData, __volumeCount: volumeCount };
      })
      .sort((a, b) => b.__volumeCount - a.__volumeCount)
      .map(({ __volumeCount, ...rest }) => rest);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/republik/proxy/oylik?year=${date}&region=${region}&district=${district}`,
            {
                headers: {
                    // O'zingizning tizimingizdagi token (masalan, localStorage'dan olingan)
                    'Authorization': 'Bearer ' + localStorage.getItem('sw_user_token') 
                }
            }
        );

        if (res && res.data) {
            // res.data.d ichidagi ma'lumotlarni saralash funksiyasiga beramiz
            const sortedData = sortByVolume(res.data.d);

            setData(sortedData);
            setLocations(res.data.l);
        }
      } catch (e) {
        console.error("Xato:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    setLabels(Array.from({ length: 12 }, (_, i) => i + 1));
  }, [date, region, district]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const setSearchHandler = (text) => {
    $("tbody tr").each(function () {
      if (
        $(this)
          .children(".fix-with")[0]
          .innerText.toUpperCase()
          .indexOf(text.toUpperCase()) > -1
      ) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <div className='table-box'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearchHandler(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <input
            type='number'
            min={2000}
            className='form-control form-control-sm'
            value={ldate}
            onChange={(e) => setLdate(e.target.value)}
          />

          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Aqlli suv oylik", date, "tblData")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div id='content'>
          <div
            id='tableFlexible'
            style={{ height: selectedRowKeys === "" ? "80vh" : "39vh" }}>
            <div ref={conponentPDF} style={{ width: "100%" }}>
              <table
                id='tblData'
                className='table table-bordered table-style fixedHeader'>
                <thead className=''>
                  <tr>
                    <th rowSpan={2} className='sticky st1'>
                      o
                    </th>

                    <th rowSpan={2} className='sticky' style={{ left: "31px" }}>
                      T/R
                    </th>

                    <th rowSpan={2} className='sticky' style={{ left: "72px" }}>
                      Stantsiya nomi
                    </th>

                    <th colSpan={12}>{date}</th>
                  </tr>

                  <tr>
                    <th>Yanvar</th>
                    <th>Fevral</th>
                    <th>Mart</th>
                    <th>Aprel</th>
                    <th>May</th>
                    <th>Iyun</th>
                    <th>Iyul</th>
                    <th>Avgust</th>
                    <th>Sentyabr</th>
                    <th>Oktyabr</th>
                    <th>Noyabr</th>
                    <th>Dekabr</th>
                  </tr>
                </thead>

                <tbody>
                  {data.length > 0
                    ? data.map((d, index) => {
                        return (
                          <tr
                            key={index}
                            onClick={() => chiz(index)}
                            className={"tr" + index}>
                            <td className='sticky st1'>
                              <input type='checkbox' />
                            </td>

                            <td className='sticky' style={{ left: "31px" }}>
                              {index + 1}
                            </td>

                            <td
                              className='text-start sticky fix-with'
                              style={{ left: "72px" }}>
                              {d.name}
                            </td>

                            {Array(12)
                              .fill()
                              .map((_, i) => {
                                return (
                                  <td
                                    style={{
                                      width: 70,
                                      minWidth: 70,
                                      maxWidth: 70,
                                    }}
                                    key={i}>
                                    {d.data
                                      ? d.data[i]
                                        ? d.data[i].volume
                                        : ""
                                      : ""}
                                  </td>
                                );
                              })}
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Oylik;
